//PrimeReact
import { Button } from "primereact/button"

//Styles
import myStyles from "../../../styles/kiosk/KioskAdmin.module.css"

export default function CloneButton({ onClick, disabled, isTabLevel }) {
  return (
    <Button
      label="Clone customization"
      className={`${myStyles.button} ${myStyles.cloneButton}  ${
        isTabLevel ? myStyles.cloneButtonTab : myStyles.cloneButtonPanel
      }`}
      onClick={onClick}
      disabled={disabled}
      tooltip="Clone the RecoveryLink Kiosk configuration from one Organization to another."
      tooltipOptions={{ position: "bottom", className: "custom-tooltip" }}
    />
  )
}
